import { HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { faker } from '@faker-js/faker';
import { IClaimMessageUpdateResponse } from 'app/claims/components/messenger/interfaces/claim-message-update-response.interface';
import { IClaimMessengerConversation } from 'app/claims/components/messenger/interfaces/claim-messenger-conversation.interface';
import { IClaimMessengerMessage } from 'app/claims/components/messenger/interfaces/claim-messenger-message.interface';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { MockHttpInterceptor } from 'app/mocks/http-mock.interceptor';
import { IMockRegistry } from 'app/mocks/interfaces/mock-registry.interface';
import { makeEndpointMatcher } from 'app/mocks/utils/make-endpoint-matcher';

export function mockCreateMessage(
    apiEndpointService: ApiEndpointService,
    interceptor: MockHttpInterceptor,
): IMockRegistry {
    const endpointKey = 'claims.conversations.createMessage';
    const endpointMatcher = makeEndpointMatcher(endpointKey, apiEndpointService);

    return {
        method: 'POST',
        ...endpointMatcher,
        handler: (
            req: HttpRequest<unknown>,
            _params: Record<string, string>,
            _current?: IClaimMessengerConversation,
            payload?: Partial<IClaimMessengerMessage>,
        ) => {
            const origin = new URL(req.url).origin;
            const url = `${ origin }/api/claims/${ _params.claimId }/conversations?topic=${ payload.topic }`;
            const current = structuredClone(interceptor.getCache<IClaimMessengerConversation>(url));

            if (!current) {
                throw new Error(`No cached conversation found for ${ url }`);
            }

            // 1) Create a new message, merging in any provided fields
            const newMsg: IClaimMessengerMessage = {
                messageId: payload?.messageId ?? faker.string.uuid(),
                author: payload?.author ?? faker.person.fullName(),
                body: payload?.body ?? '',
                time: payload?.time ?? new Date().toISOString(),
                isAdjuster: payload?.isAdjuster ?? false,
                isAutoMessage: payload?.isAutoMessage ?? false,
                isMessageRead: payload?.isMessageRead ?? false,
                isSystemMessage: payload?.isSystemMessage ?? false,
                isStale: payload?.isStale ?? false,
                topic: payload?.topic,
            };

            // 2) Mutate the in-memory conversation
            current.messages.push(newMsg);
            current.totalCount = current.messages.length;
            current.unreadAdjusterCount = current.messages.filter(m => !m.isMessageRead).length;

            interceptor.setCache(url, current);

            // 3) Build the create-response
            const body: IClaimMessageUpdateResponse = {
                claimId: current.claimId,
                message: newMsg,
            };

            return new HttpResponse({
                status: HttpStatusCode.Created,
                body,
            });
        },
    };
}
